(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rs-process-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-process-video')) {
    customElements.define('rs-process-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('dialog');
        this.inline = this.querySelector('[data-inline-player]');
        this.playButton = this.querySelector('[data-video-action="play"]');
        this.soundButton = this.querySelector('[data-video-action="sound"]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.manualPaused = false;
        this.visible = false;
        this.video.muted = true;
        this.video.controls = false;
        this.querySelector('[data-video-controls]').hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-video-action]');
          if (!button) return;
          const action = button.dataset.videoAction;
          if (action === 'play') {
            this.manualPaused = !this.video.paused;
            if (this.manualPaused) this.video.pause();
            else this.play();
          } else if (action === 'sound') {
            this.video.muted = !this.video.muted;
          } else if (action === 'expand') {
            this.querySelector('[data-dialog-player]').append(this.video);
            this.video.controls = true;
            this.dialog.showModal();
            this.play();
          } else if (action === 'close') {
            this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.manualPaused = this.video.paused;
          this.inline.append(this.video);
          this.video.controls = false;
          if (!this.visible || document.hidden) this.video.pause();
          else if (!this.manualPaused) this.play();
          this.querySelector('[data-video-action="expand"]').focus({ preventScroll: true });
        }, options);
        for (const name of ['play', 'pause', 'volumechange']) this.video.addEventListener(name, () => this.updateControls(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.25 });
        this.observer.observe(this);
        this.updateControls();
      }
      play() {
        this.video.play().catch(() => this.updateControls());
      }
      syncPlayback() {
        if (document.hidden) {
          this.video.pause();
          return;
        }
        if (this.dialog.open) return;
        if (!this.visible || this.motion.matches) this.video.pause();
        else if (this.dataset.autoplay === 'true' && !this.manualPaused) this.play();
      }
      updateControls() {
        const paused = this.video.paused;
        const muted = this.video.muted;
        this.playButton.setAttribute('aria-label', paused ? this.dataset.play : this.dataset.pause);
        this.querySelector('[data-icon-play]').toggleAttribute('hidden', !paused);
        this.querySelector('[data-icon-pause]').toggleAttribute('hidden', paused);
        this.soundButton.setAttribute('aria-label', muted ? this.dataset.unmute : this.dataset.mute);
        this.soundButton.setAttribute('aria-pressed', String(!muted));
        this.querySelector('[data-icon-muted]').toggleAttribute('hidden', !muted);
        this.querySelector('[data-icon-sound]').toggleAttribute('hidden', muted);
      }
      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
